module.exports = __webpack_public_path__ + "assets/img/email-6b45ef5d.png";